/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /*
   * Вид для правого виджета в профиле организатора СП
   */
  app.JointPurchaseBillView = app.View.extend({
    events: {
      'click .js-create-purchase': 'createPurchase',
      'change .js-agreement': 'updateButtonAvailability',
      'click .js-datepicker-field': 'toggleDatepicker'
    },
    
    run: function (options) {
      if (options && options.organizerModel) {
        this.organizerModel = options.organizerModel;
      }
      this.tomorrow = new Date();
      this.tomorrow.setDate(this.tomorrow.getDate() + 1);
      this.model = new app.Model();
      this.model.urlRoot = app.entryScriptName + '/api/v3/jp-purchase';
      this.onModerationTemplate = app.helpers.TemplateHelper.getTemplate('#jp-purchase-on-moderation-aside');
      this.editFormTemplate = app.helpers.TemplateHelper.getTemplate('#jp-purchase-edit-form-aside');
      this.purchaseCreatedTemplate = app.helpers.TemplateHelper.getTemplate('#jp-purchase-created-aside');
      this.consultantPhoneTemplate = app.helpers.TemplateHelper.getTemplate('#jp-purchase-consultant-phone-number-aside');
      
      new app.DatepickerView();
      this.$('.js-datepicker').datepicker({
        dateFormat: 'd MM yy',
        minDate: this.tomorrow,
        onSelect: function () {
          var date = this.$('.js-datepicker').datepicker('getDate');
          this.date = moment(date).format('YYYY-MM-DD HH:mm');
          this.updateButtonAvailability();
        }.bind(this)
      });
      this.initPopup();
      this.listenTo(this.organizerModel, 'change:moderation_status', this.render);
      this.listenTo(this.model, 'sync', this.renderCreatedPurchase);
      this.updateButtonAvailability();
    },
    
    initPopup: function () {
      delete this.popup;
      var popupSelector = $('[data-popup-id="rules"]');
      this.popup = new als.Popup(popupSelector, $('.js-show-rules-popup'));
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          popupSelector.css({
            width: '80%',
            height: '65%',
            position: 'absolute',
            padding: '2em',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            margin: 'auto'
          });
        }
      );
    },
    
    toggleDatepicker: function () {
      var arrowIcon = this.$('.js-datepicker-field .arrow_down');
      arrowIcon.toggleClass('arrow_up');
      if (arrowIcon.hasClass('arrow_up')) {
        this.$('.js-datepicker').datepicker('show');
      } else {
        this.$('.js-datepicker').datepicker('hide');
      }
    },
    
    render: function (model, status) {
      if (status === 1) {
        this.$el.html(this.onModerationTemplate());
      } else if (status === 0) {
        this.$el.html(this.editFormTemplate());
      }
      this.initPopup();
      // чтобы в городе Сима-лэнд блок с консультацией не рендерился дважды
      if (!this.$('.b-aside-text').length) {
        this.$el.append(this.consultantPhoneTemplate());
      }
    },
    
    createPurchase: function () {
      var data = {
        user_id: app.user.get('id'),
        jp_status_id: 1
      };
      if (!this.date) {
        data.ended_at = moment(this.tomorrow).format('YYYY-MM-DD HH:mm');
      } else {
        data.ended_at = this.date;
      }
      this.model.save(data, {wait: true});
    },
    
    renderCreatedPurchase: function () {
      this.$el.html(this.purchaseCreatedTemplate({
        date: this.model.get('ended_at'),
        id: this.model.get('id')
      }));
      this.initPopup();
      this.trigger('purchaseCreated');
    },

    /**
     * Делаем кнопку "Создать совместную покупку" активной,
     * если выбрана дата завершения приема заявок и поставлена галочка согласия с правилами.
     * Если условия не соблюдены, деактивируем кнопку
     */
    updateButtonAvailability: function () {
      var isRulesAccepted = this.$('.js-agreement').prop('checked');
      var isDateSelected = !!this.date;
      var isButtonDisabled = !(isRulesAccepted && isDateSelected);

      this.$('.js-create-purchase').attr('disabled', isButtonDisabled);
    }
  });
})(jQuery);

}.call(window));